import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import { Grid } from '@progress/kendo-react-grid';
import GridLoader from '@hobs/components/Grid/GridLoader';
import Columns from '@hobs/components/Grid/Columns';
import { createLoadingSelector } from '@hobs/utils/loading';
import Icon from '@hobs/components/Icon';
import WithRoles from '@hobs/hocs/WithRoles';
import Input from '@hobs/components/Input';
import { H1 } from '@hobs/components/Headings';
import ShortId from 'shortid';
import deepcopy from 'deepcopy';
import _Catalog from '@hobs/containers/Catalog';
import {
  withDataStateLocalOverrides,
  withGridLocalOverrides,
  onUserResetSettings
} from '@hobs/utils/grid/overrides';
import { getCatalogGrid } from '@hobs/actions/gridSelections';
import { queryOData, resetOData } from '@hobs/actions/odata';
import { exportCatalog, uploadCatalog } from '@hobs/actions/catalog';
import { deleteCatalogItem } from '@hobs/actions/catalogItem';
import { PAGE_SIZES } from '@hobs/utils/constants';

class Catalog extends _Catalog {
  LSdataStateName = `Catalog${this.props.user.CurrentExerciseId}.dataState`;
  LSGridPropsName = `Catalog${this.props.user.CurrentExerciseId}.grid.props`; 
  getGridColumns() {
    return this._getGridColumns();
  }

  onUserSaveSettings = () => {
    localStorage.setItem(this.LSdataStateName, JSON.stringify(this.state.dataState));
    localStorage.setItem(
      this.LSGridPropsName,
      JSON.stringify({
        columns: this.grid.current.columns
      })
    );
  };

  onUserResetSettings = onUserResetSettings(
    this.LSdataStateName,
    this.LSGridPropsName,
    null,
    () => {
      const columns = this.getGridColumns();

      this.setState(
        {
          gridKey: ShortId.generate(),
          columns,
          dataState: this.defaultDataState
        },
        () => {
          this.queryOData();
        }
      );
    }
  );

  constructor(props) {
    super(props);

    this.exportRef = React.createRef();
    this.grid = React.createRef();

    this.defaultGridColumns = this.getGridColumns()

    this.defaultDataState = {
      take: 20,
      sort: [{ field: 'Code', dir: 'acs' }],
      skip: 0,
    };
    const defaultState = {
      dataState: withDataStateLocalOverrides(
        deepcopy(this.defaultDataState),
        this.LSdataStateName
      ),
      remove: this.state.remove,
      upload: this.state.upload,
      gridKey: ShortId.generate(),
      customFilters: {},
      columns: withGridLocalOverrides(
        deepcopy(this.defaultGridColumns),
        this.LSGridPropsName
      ),
      openDialog: false,
      selectedRows: {},
      isAllSelected: false,
      previousWindowScrollOffset: null
    };

    this.state = {
      ...defaultState
    };
  }

  getColumns(){
    return withGridLocalOverrides(
      deepcopy(this.getGridColumns()),
      this.LSGridPropsName
    )
  }

  render() {
    const { t } = this.props;

    return (
      <div className="catalog-view">
        <H1>{t('Catalog')}</H1>
        <div className="catalog-view--heading">
          <div className="catalog-view--left">
            <div className="catalog-view--search">
              <Input
                search
                icon={<Icon icon="search" />}
                placeholder="search"
                onKeyUp={this.handleQuickSearchChange}
              />
            </div>
          </div>
        </div>
        <div>
          <Grid
            resizable={true}
            sortable={true}
            key={this.state.gridKey}
            ref={this.grid}
            pageable={{
              pageSizes: PAGE_SIZES
            }}
            {...this.state.dataState}
            {...this.props.oData}
            onDataStateChange={this.dataStateChange}
          >
            {Columns({
              columns: this.getColumns(),
              onSave: this.onUserSaveSettings,
              onReset: this.onUserResetSettings,
              dataState: this.state.dataState
            })}
          </Grid>
          {this.props.isLoading && <GridLoader />}
        </div>
      </div>
    );
  }
}

Catalog.propTypes = {
  isLoading: PropTypes.bool,
  oData: PropTypes.object,
  queryOData: PropTypes.func,
  resetOData: PropTypes.func,
  t: PropTypes.func
};

const oDataLoading = createLoadingSelector(['OData']);
const mapStateToProps = state => ({
  isLoading: oDataLoading(state),
  oData: state.odata,
  catalogGrid: state.gridSelections.catalogGrid
});

const mapDispatchToProps = {
  getCatalogGrid,
  queryOData,
  resetOData,
  exportCatalog,
  uploadCatalog,
  deleteCatalogItem
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(WithRoles(Catalog))));
